import { FragmentOf } from "gql.tada";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { FootnoteRichText } from "@components/shared/core/FootnoteRichText";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import cx from "classnames";

type InsightsBlockItem = FragmentOf<typeof RichEntryFragment> | null;

export const CaseStudyInsightsBlockGroup = ({
  items,
  variant = false,
}: {
  items: InsightsBlockItem[];
  variant?: string | boolean;
}) => {
  const blocks = items.filter((b): b is NonNullable<typeof b> => b !== null);
  if (blocks.length === 0) return null;

  return (
    <section className="container-base grid dsk:grid-cols-4 gap-x-4 gap-y-10 py-[150px] justify-center">
      {blocks.map((block, i) => (
        <div
          key={i}
          className={cx('p-8 rounded-xl relative overflow-hidden flex flex-col w-full max-w-[330px] dsk:max-w-none dsk:min-h-[380px] items-center justify-center text-center', variant === 'border' && 'border border-brand-black !text-palette-current-highlight')}
          style={{ alignSelf: "start" }}
        >
          <FootnoteRichText content={block} options={{
            renderNode: {
              [BLOCKS.HEADING_1]: (_, children) => (
                <p className={cx('text-heading-1 xl:text-[10cqw] pb-4 z-10', variant !== 'border' ? 'text-neutral-light' : '')}>
                  {children}
                </p>
              ),
              [BLOCKS.PARAGRAPH]: (_, children) => (
                <p className="z-10 grow text-body-large text-palette-current-highlight">
                  {children}
                </p>
              ),
              [INLINES.ENTRY_HYPERLINK]: (_, children) => (
                <span className="inline">{children}</span>
              ),
            },
          }} />
        </div>
      ))}
    </section>
  );
};
